<template>
  <div class="page-content">
    <div class="custom-detail">
      <el-breadcrumb separator="/" class="egl-breadcrumb">
        <el-breadcrumb-item :to="{ path: '/custom' }">{{ $locale("sideMenu.cinemaWebsite.custom.title") }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $locale("cinemaWebsite.custom.dialog.title") }}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-form
        class="egl-elm egl-detail"
        :model="form"
        :rules="formRules"
        ref="detailForm"
        label-position="top"
      >
        <el-col :span="24">
          <div class="form-module-tit">{{ $locale("cinemaWebsite.custom.dialog.title") }}</div>
        </el-col>
        <el-row>
          <el-col :span="10">
            <el-form-item
              :label="$locale('cinemaWebsite.custom.dialog.form.title')"
              prop="title"
            >
              <el-input
                :placeholder="$locale('cinemaWebsite.custom.dialog.form.title.plsInput')"
                v-model.number="form.title"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <el-form-item
              :label="$locale('cinemaWebsite.custom.dialog.form.sort')"
              prop="sort"
            >
              <el-input
                style="width:140px;"
                v-model.number="form.sort"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              :label="$locale('cinemaWebsite.custom.dialog.form.content')"
              prop="content"
            >
              <editor v-model="form.content" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row>
        <el-col :span="24" class="ta-r">
          <el-button style="width: 200px;" class="egl-btn-yellow" @click="save_fn">{{ $locale("global.confirm2") }}</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import Editor from "@/components/common/Tinymce/Rich";
import { createCustomService, getCustomDetailService, updateCustomService } from "@/helpers/service/api/cinemaWebsite";
import countDownAlert from "@/utils/countDownAlert";

export default {
  data() {
    return {
      form: {
        title: "",
        sort: 0,
        content: this.$richText.tinymceHtml,
      },
      formRules: {
        title: [
          {
            required: true,
            message: this.$locale("cinemaWebsite.custom.dialog.form.title.required"),
            trigger: [ "blur" ]
          }
        ],
        sort: [
          {
            required: true,
            message: this.$locale("cinemaWebsite.custom.dialog.form.sort.required"),
            trigger: [ "blur" ]
          }
        ]
      },
      actionType: this.$route.path.indexOf("create") > -1 ? "create" : "edit"
    };
  },
  created() {
    if(this.$route.path.indexOf("update") > -1) {
      getCustomDetailService({ id: this.$route.params.id }).then(res => {
        this.form = {
          ...res.data,
          content: this.$util.decodeBase64(res.data.content)
        };
      });
    }
  },
  methods: {
    requestScuessFn(res, countDownText) {
      if (!res.success) { return; }
      countDownAlert({
        content: countDownText,
        callback: () => {
          this.$router.push("/custom");
        }
      });
    },
    save_fn() {
      const requestParam = {
        ...this.form,
        content: this.$util.encodeBase64(this.form.content),
        cinemaId: window.localStorage.getItem("cinemaId"),
      };
      this.$refs.detailForm.validate(valid => {
        if (valid) {
          if (this.actionType === "create") {
            createCustomService(requestParam).then(res => {
              /** 
               * data {} | null
               * 
              */
              this.requestScuessFn(res, this.$locale("global.createSuccessfully"));
            });
          } else {
            updateCustomService(requestParam).then(res => {
              this.requestScuessFn(res, this.$locale("global.updateSuccessfully"));
            });
          }
        } else {
          setTimeout(() => {
            const isError = document.getElementsByClassName("is-error");
            isError[0].querySelector("input").focus();
          }, 100);

          return false;
        }
      });
    }
  },
  components: {
    Editor
  }
};
</script>